import { useApiMutation } from '@/shared/hooks/useApi';

import { orderService } from '../services/orderService';
import {
  CreateOrderMemoRequest,
  UpdateOrderAmountRequest,
  UpdateOrderMemoRequest,
  UpdateOrderStatusRequest,
} from '../types/orderTypes';

export const useUpdateOrderAmount = () => {
  return useApiMutation(
    ({
      orderUuid,
      data,
    }: {
      orderUuid: string;
      data: UpdateOrderAmountRequest;
    }) => orderService.updateOrderAmount(orderUuid, data),
  );
};

export const useCreateOrderMemo = () => {
  return useApiMutation(
    ({
      orderUuid,
      data,
    }: {
      orderUuid: string;
      data: CreateOrderMemoRequest;
    }) => orderService.createOrderMemo(orderUuid, data),
  );
};

export const useUpdateOrderMemo = () => {
  return useApiMutation(
    ({
      orderMemoUuid,
      data,
    }: {
      orderMemoUuid: string;
      data: UpdateOrderMemoRequest;
    }) => orderService.updateOrderMemo(orderMemoUuid, data),
  );
};

export const useDeleteOrderMemo = () => {
  return useApiMutation((orderMemoUuid: string) =>
    orderService.deleteOrderMemo(orderMemoUuid),
  );
};

export const useUpdateOrderStatus = () => {
  return useApiMutation(
    ({
      orderUuid,
      data,
    }: {
      orderUuid: string;
      data: UpdateOrderStatusRequest;
    }) => orderService.updateOrderStatus(orderUuid, data),
  );
};
